import { Id } from "./id";

type ConfigurationProfile = {
  name: string;
  roles: Id[];
  columns: { key: string }[];
};

type ProjectMembersListingConfiguration = ConfigurationProfile[];

const projectMembersListingConfiguration: ProjectMembersListingConfiguration =
  [];

export type { ProjectMembersListingConfiguration };

export { projectMembersListingConfiguration };
